import { render, staticRenderFns } from "./Papel.vue?vue&type=template&id=eb7f895c"
import script from "./Papel.vue?vue&type=script&lang=js"
export * from "./Papel.vue?vue&type=script&lang=js"
import style0 from "./Papel.vue?vue&type=style&index=0&id=eb7f895c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports